<!-- Main Admin Layout Wrapper -->
<div class="d-flex flex-column min-vh-100 bsb-dashboard-wrapper">
  <!-- Modern Header Nav -->
  <header class="navbar navbar-expand-lg border-bottom px-4 py-2 bg-body-tertiary shadow-sm">
    <div class="container-fluid p-0 d-flex align-items-center justify-content-between">
      <!-- Brand & User Profile -->
      <div class="d-flex align-items-center gap-3">
        <a class="navbar-brand d-flex align-items-center" href="#">
          <img src="../assets/app_icon_modified.png" class="rounded-circle border" alt="UPG logo" width="40"
            height="40" />
        </a>
        <span class="fw-semibold fs-5 text-body"> Hi, {{ login_user }} </span>
      </div>

      <!-- Action Utilities -->
      <div class="d-flex align-items-center gap-2">
        <!-- Dark Mode Toggle Button -->
        <button type="button"
          class="btn btn-sm btn-link text-decoration-none me-2 rounded-circle border text-body d-inline-flex align-items-center justify-content-center"
          style="width: 36px; height: 36px; padding: 0" (click)="toggleDarkMode()">
          <i [ngClass]="isDarkMode() ? 'fa-regular fa-sun fs-5 text-warning' : 'fa-regular fa-moon fs-5'"></i>
        </button>

        <!-- Dropdown Menu for Cleaner Space Saving -->
        <div class="dropdown">
          <button class="btn btn-sm rounded px-3 border dropdown-toggle btn-light" type="button"
            data-bs-toggle="dropdown">
            Account Settings
          </button>
          <ul class="dropdown-menu dropdown-menu-end shadow border-0 mt-2">
            <li>
              <button class="dropdown-item py-2" type="button" data-bs-toggle="modal"
                data-bs-target="#changePasswordModal">
                <i class="fa-solid fa-key me-2 text-muted"></i>Change Password
              </button>
            </li>
            <li>
              <hr class="dropdown-divider" />
            </li>
            <li>
              <button class="dropdown-item py-2 text-danger" type="button" data-bs-toggle="modal"
                data-bs-target="#logoutModal">
                <i class="fa-solid fa-sign-out me-2"></i>Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>

  <!-- Dashboard Main Frame -->
  <div class="d-flex flex-grow-1">
    <!-- Collapsible/Responsive Left Sidebar -->
    <aside class="col-2 col-md-3 col-lg-2 border-end py-4 transition-all px-2 bg-body-tertiary">
      <ul class="nav nav-pills flex-column gap-1 w-100">
        @for (data of links; track data.link) {
        <li class="nav-item">
          <a [routerLink]="data.link"
            class="nav-link d-flex align-items-center px-3 py-2 rounded-3 text-start transition-base text-body"
            [routerLinkActive]="'active shadow-sm text-white'" #rla="routerLinkActive">
            <i class="{{ data.icon }} fs-5 me-md-3 me-0"></i>
            <span class="d-none d-md-inline small fw-medium">{{ data.name }}</span>
          </a>
        </li>
        }
      </ul>
    </aside>

    <!-- Main Dynamic Content Workspace -->
    <main class="flex-grow-1 p-2 overflow-y-auto bg-body-secondary">
      <div class="card border-0 shadow-sm rounded-4 h-100 bg-body">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>

<!-- ========================================== -->
<!-- MODALS SECTION                             -->
<!-- ========================================== -->

<!-- Logout Modal -->
<div class="modal fade" id="logoutModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content shadow border-0 bg-body">
      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title fw-bold text-danger">Logout</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-body-secondary">Are you sure you want to end your session?</div>
      <div class="modal-footer border-0 pt-0">
        <button type="button" class="btn btn-sm btn-secondary opacity-75" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-sm btn-danger px-3" (click)="submitAdminLogout()"
          [disabled]="isUploading()">
          @if (isUploading()) {
          <span class="spinner-border spinner-border-sm" role="status"></span>
          } @else {
          <span>Confirm Logout</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Change Password Modal -->
<div class="modal fade" id="changePasswordModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow border-0 bg-body">
      <div class="modal-header border-bottom">
        <h5 class="modal-title fw-semibold">Change Security Password</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body py-4">
        <form [formGroup]="changePasswordForm">
          <!-- New Password Input Field -->
          <div class="mb-3">
            <label class="form-label small fw-medium text-body-secondary">New Password</label>
            <div class="input-group shadow-sm rounded">
              <input [type]="showNewPassword() ? 'text' : 'password'" class="form-control" formControlName="newPassword"
                placeholder="Minimum 6 characters" />
              <button class="btn btn-outline-secondary border" type="button"
                (click)="showNewPassword.update((val) => !val)">
                <i
                  ngClass]="showNewPassword() ? 'fa-solid fa-eye-slash text-muted' : 'fa-solid fa-eye text-primary'"></i>
              </button>
            </div>
          </div>

          <!-- Confirm Password Input Field -->
          <div class="mb-3">
            <label class="form-label small fw-medium text-body-secondary">Confirm New Password</label>
            <div class="input-group shadow-sm rounded">
              <input [type]="showConfirmPassword() ? 'text' : 'password'" class="form-control"
                formControlName="confirmPassword" placeholder="Match new password" />
              <button class="btn btn-outline-secondary border" type="button"
                (click)="showConfirmPassword.update((val) => !val)">
                <i [ngClass]="
                    showConfirmPassword() ? 'fa-solid fa-eye-slash text-muted' : 'fa-solid fa-eye text-primary'
                  "></i>
              </button>
            </div>
          </div>
        </form>

        @if (isError()) {
        <div class="alert alert-danger d-flex align-items-center gap-2 mt-3 mb-0 py-2 border-0 shadow-sm" role="alert">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <small>{{ errorMessage() }}</small>
        </div>
        }
      </div>
      <div class="modal-footer border-top">
        <button type="button" class="btn btn-sm btn-secondary opacity-75" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-sm btn-primary px-4 shadow"
          [disabled]="!changePasswordForm.valid || isUploading()" (click)="submitChangePassword()">
          @if (isUploading()) {
          <span class="spinner-border spinner-border-sm" role="status"></span>
          } @else {
          <span>Update Password</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>